// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"c4d3e8de","403":"29515f3c","484":"8b69875b","551":"957b7bba","869":"08025929","974":"46a47ffc"}[chunkId] + ".chunk.js";
};